import React, {FunctionComponent} from "react";
import './WizardStepAdresse.scss';
import {MscWizardProps} from "../../interfaces";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import Api from "../../Api";

const WizardStepAdresse: FunctionComponent<MscWizardProps> = (props) => {
    const adresseRef = React.useRef<HTMLInputElement>(null);
    const [waitForTypeEnd, setWaitForTypeEnd] = React.useState<number | null>(null);
    const abortController = new AbortController();

    return <div className="msc-anmeldung__wizard-step-one">
        <h1>Für welche Adresse wollen Sie Benachrichtigungen empfangen?</h1>
        <div className="msc-anmeldung__input-autocomplete-container">
            <input
                className={`msc-anmeldung__input msc-anmeldung__input-suchwoerter ${props.state.loading || props.state.vorschlaegeAdressen !== null ? 'msc-anmeldung__input-autocomplete-input' : ''}`}
                type="text"
                autoComplete="off"
                placeholder="Suchen Sie nach einer Adresse"
                ref={adresseRef}
                value={props.state.suchewoerter}
                onChange={evt => {
                    props.dispatch({
                        type: "SET_SUCHWOERTER",
                        value: evt.target.value
                    })
                    //abortController.abort();
                    if (waitForTypeEnd !== null) {
                        window.clearTimeout(waitForTypeEnd);
                    }
                    if (evt.target.value.trim().length) {
                        const newTimeout = window.setTimeout(() => {
                            Api.findeAdresse(evt.target.value, abortController.signal)
                                .then(response => props.dispatch({
                                    type: "SET_ADRESSEN_AUSWAHL",
                                    value: response.data
                                }))
                                .catch(error => console.error(error))
                        }, 500);
                        setWaitForTypeEnd(newTimeout);
                    }
                }}
            />
            {props.state.loading || props.state.vorschlaegeAdressen !== null ? <div className="msc-anmeldung__input-autocomplete">
                {props.state.loading ? <div className="msc-anmeldung__input-autocomplete__loading">
                    <FontAwesomeIcon icon={faSpinner} pulse={true}/>
                </div> : <></>}
                <div className="msc-anmeldung__input-autocomplete__items">

                    {props.state.vorschlaegeAdressen?.data.map((a, i) => <div
                        className={`msc-anmeldung__vorschlag-adresse-${i} msc-anmeldung__input-autocomplete__item ${
                            a.id === props.state.ausgewaehlteAdresse?.id ? 'msc-anmeldung__input-autocomplete__item-selected' : ''
                        }`}
                        key={`msc-anmeldung__vorschlag-adresse-${i}`}
                        onClick={() => props.dispatch({
                            type: "SET_ADRESSE_AUSGEWAEHLT",
                            value: a
                        })}
                    >
                        {[`${a.strasse} ${a.hausnummer}`.trim(), `${a.postleitzahl} ${a.ort}`.trim()].filter(s => s.length).join(', ')}
                    </div>)}
                    {(props.state.vorschlaegeAdressen?.total || 0) > (props.state.vorschlaegeAdressen?.data.length || 0)? <div className="msc-anmeldung__input-autocomplete__item msc-anmeldung__input-autocomplete__item-no-hover">
                        Ist ihre Adresse nicht dabei? Dann versuchen Sie ihre Suche zu verfeinern.
                    </div> : <></>}
                    {!props.state.loading && (props.state.vorschlaegeAdressen?.data.length || -1) <= 0 ? <div className="msc-anmeldung__input-autocomplete__item msc-anmeldung__input-autocomplete__item-no-hover">
                        Es tut uns leid. Anhand ihrer Eingabe konnten wir keine Adresse ermitteln.
                    </div>: <></>}
                </div>
            </div> : <></>}
        </div>
    </div>
};

export default WizardStepAdresse
